import * as React from "react";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

/** Matches Trade Log buy / sell gradient badges inside shadcn data tables. */
export const TRADE_POSITION_SIDE_BADGE_CLASS =
  "rounded-[6px] border-0 bg-transparent font-[family-name:var(--font-primary)] font-medium text-white shadow-none [&_svg]:text-white";

export type TradePositionSide = "buy" | "sell" | "long" | "short";

function isBuySide(side: TradePositionSide): boolean {
  return side === "buy" || side === "long";
}

function defaultSideLabel(side: TradePositionSide): string {
  if (side === "buy") return "Buy";
  if (side === "sell") return "Sell";
  if (side === "long") return "Long";
  return "Short";
}

export function TradePositionSideBadge({
  side,
  label,
  className,
}: {
  side: TradePositionSide;
  label?: string;
  className?: string;
}): React.ReactElement {
  const isBuy = isBuySide(side);

  return (
    <Badge
      data-trade-log-type-badge={isBuy ? "buy" : "sell"}
      className={cn(TRADE_POSITION_SIDE_BADGE_CLASS, className)}
    >
      {label ?? defaultSideLabel(side)}
    </Badge>
  );
}
